<template>
    <div class="my-next-card-wrapper grid grid-cols-12 gap-4 mt-6 relative">
        <div class="col-span-12 flex justify-end mb-4 px-1">
            <a
                href="#"
                @click.prevent="showAffiliateModal(true)"
                class="text-orange text-xs hover:text-orange-400 focus:text-slate-500 focus:outline-slate-300 rounded"
            >
                Affiliate Disclosure
            </a>
        </div>
        <div
            class="hotel-results col-span-12 xxl:col-span-9 grid relative"
            id="search-results-top"
        >
            <div
                class="col-span-12 lg:pl-4 lg:pr-0 grid grid-cols-12 gap-2 relative"
            >
                <!-- SEARCH FORM -->
                <div
                    class="search-filters relative overflow-visible rounded-lg col-span-12 flex flex-col justify-between mb-7"
                >
                    <search-form />
                </div>
                <!-- SEARCH FILTER BAR -->
                <SearchFilterBar class="mb-7" />
                <!-- LOADING -->
                <!-- SEARCH RESULTS -->
                <div class="fixed inset-0 z-[999]" v-if="showOnMap">
                    <!-- <Suspense> -->
                    <MapResults />
                    <!-- </Suspense> -->
                </div>
                <SearchResults
                    v-if="!loading"
                    @page-changed="handlePageChanged"
                />
            </div>
        </div>
        <LoadingState :loading="loading" />
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useHotelsStore } from '@/store/hotels';
import { useAppStore } from '@/store/app';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
import SearchForm from '@/components/hotels/search/search-form/search-form.vue';
import SearchResults from '@/components/hotels/search/search-results.vue';
import SearchFilterBar from '@/components/hotels/search/search-filter-bar/search-filter-bar.vue';
import MapResults from '@/components/hotels/search/map-results/map-results.vue';

export default {
    components: {
        LoadingState,
        SearchForm,
        SearchResults,
        SearchFilterBar,
        MapResults,
    },
    setup() {
        const appStore = useAppStore();
        const hotelsStore = useHotelsStore();
        const { showOnMap, loading } = storeToRefs(hotelsStore);

        const showAffiliateModal = (val) => {
            appStore.setShowAffiliateModal(val);
        };

        const handlePageChanged = () => {
            const top = document.getElementById('search-results-top');

            if (top) {
                top.scrollIntoView({ behavior: 'smooth' });
            }
        };

        return {
            loading,
            handlePageChanged,
            showAffiliateModal,
            showOnMap,
        };
    },
};
</script>
